import { isEqual } from "es-toolkit";

export const transformDefaultsToUndefined = <T extends Record<string, unknown>>(values: T, defaults: T) =>
  Object.fromEntries(
    Object.entries(values).map(([key, value]): [typeof key, typeof value] => {
      if (Array.isArray(value)) {
        return [key, isEqual(value, defaults[key]) ? undefined : value];
      }
      if (value !== null && typeof value === "object") {
        if (isEqual(value, defaults[key])) {
          return [key, undefined];
        }
        return [
          key,
          transformDefaultsToUndefined(value as Record<string, unknown>, defaults[key] as Record<string, unknown>),
        ];
      }
      return [key, value === defaults[key] ? undefined : value];
    }),
  ) as T;
